/*eslint-disable*/
import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// @material-ui/icons
import Home from "@material-ui/icons/Home";
import Info from "@material-ui/icons/Info";
import Call from "@material-ui/icons/Call";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import Description from "@material-ui/icons/Description";
import RetailHome from "@material-ui/icons/Storefront";

import NewHome from "../../../assets/img/icons/new/newhome.svg";

// core components
import Button from "../../CustomButton";

import drawerLinksStyle from "./drawer-links-style";



function DrawerLinks({ ...props }) {
    const { classes, loginPage, currLocation, authenticated } = props;
    return (
        !authenticated ? (
            <List className={classes.list}>
                {currLocation === 'retail' ?
                    <ListItem className={classes.listItem}>
                        <Button
                            href={"/home"}
                            color="transparent"
                            className={classes.navLink}
                        >
                            <Home className={classes.icons} /> Home
                        </Button>
                    </ListItem> :
                    <ListItem className={classes.listItem} style={{ marginRight: '20px' }}>
                        <Button
                            href={"/retail"}
                            color="transparent"
                            className={classes.navLink}
                        >
                            <RetailHome className={classes.icons} /> Retail
                        </Button>
                    </ListItem>
                }
                {/* <ListItem className={classes.listItem}>
                <Button
                    // href={"/relationship"}
                    href={"/home"}
                    color="transparent"
                    className={classes.navLink}
                >
                    <WbIncandescent className={classes.icons} /> Solutions
                </Button>
            </ListItem> */}
                <ListItem className={classes.listItem}>
                    <Button
                        href={"/aboutus"}
                        color="transparent"
                        className={classes.navLink}
                    >
                        <Info className={classes.icons} /> About Us
                    </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                    <Button
                        href={"/contactus"}
                        color="transparent"
                        className={classes.navLink}
                    >
                        <Call className={classes.icons} /> Contact Us
                    </Button>
                </ListItem>
                {/* <ListItem className={classes.listItem}>
                <Button
                    href="/webcrawler"
                    color="transparent"
                    className={classes.navLink}
                >
                    <Language className={classes.icons} /> Web Crawler
                </Button>
            </ListItem> */}
                {!loginPage ?
                    <div>
                        <ListItem className={classes.listItem}>
                            <Button
                                href={"/termsofuse"}
                                color="transparent"
                                className={classes.navLink}
                            >
                                <Description className={classes.icons} /> Terms of Use
                            </Button>
                        </ListItem>
                        <ListItem className={classes.listItem}>
                            <Button
                                href={"/privacy"}
                                color="transparent"
                                className={classes.navLink}
                            >
                                <VerifiedUser className={classes.icons} /> Privacy
                            </Button>
                        </ListItem>
                    </div> : ""
                }
            </List>
        )
            :
            <List className={classes.list}>

            </List>
    );
}

export default withStyles(drawerLinksStyle)(DrawerLinks);
